import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SubscriptionsSelector } from '../components/subscription-selector/SubscriptionsSelector.view';

import type { RootState } from '../types/state.types';

export const SubscriptionsSelectorContainer: React.FC<{
  currentSubId: string;
  currentSubName: string;
}> = ({ currentSubId, currentSubName }) => {
  const subscriptions = useSelector((state: RootState) => state.subscriptions);

  const sortedSubs = useMemo(
    () =>
      [...subscriptions]?.sort((sub1, sub2) =>
        sub1.name.toLowerCase() < sub2.name.toLowerCase() ? -1 : 1
      ),
    [subscriptions]
  );

  return (
    <SubscriptionsSelector
      currentSubId={currentSubId}
      currentSubName={currentSubName}
      subscriptions={sortedSubs}
    />
  );
};
